import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ButtonBase from '@mui/material/ButtonBase';
import useMediaQuery from '@mui/material/useMediaQuery';

import { Map } from '@functions/index';

import translate from '@localise/translate';

import SectionWrap from '@layout/SectionWrap';

import styles from './style.scss';

const ContactSimple = (): JSX.Element => {
  // const [data, setData] = useState<Record<string, string>>({});
  // const [sending, setSending] = useState(false);
  // const [sent, setSent] = useState(false);

  const useMobile = useMediaQuery('(max-width: 1280px)');

  // const emailInvalid = data.email && !Validate.email(data.email.trim());

  /*
  const onSubmit = (e: FormEvent) => {
    e.preventDefault();

    setSending(true);

    fetch(`${Env.apiUrl()}/web-project/email/send`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // 'X-API-KEY': '',
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((error) => {
            throw error;
          });
        }
        return response.json();
      })
      .then(() => {
        setSent(true);
      })
      .catch((error) => {
        alert(JSON.stringify(error));
        setSent(false);
        setSending(false);
      });
  }; */

  const buildOpeningHours = (days: Record<string, string>, hours: Record<string, string>) => {
    const rows: JSX.Element[] = [];

    Object.keys(days).forEach((day) => {
      return rows.push(
        <Box key={day} display="flex" justifyContent="space-between">
          <Typography variant="body2" className={styles.text} sx={{ minWidth: '36px' }}>
            {days[day]}
          </Typography>
          <Typography variant="body2" className={hours[day].includes('-') ? styles.text : styles.textDanger}>
            {hours[day]}
          </Typography>
        </Box>
      );
    });

    if (translate('contact.lunchVisible')) {
      rows.push(
        <Typography key="splitter" variant="body2">
          {' '}
        </Typography>
      );
      rows.push(
        <Typography key="lunch" variant="body2" className={styles.textDanger} color="danger">
          {translate('contact.lunch')}&nbsp;&nbsp;&nbsp;{translate('openingHoursLunch')}
        </Typography>
      );
    }

    return rows;
  };

  return (
    <SectionWrap mobileFullWidth>
      <Typography variant="h2" color="white">
        {translate('contact.title')}
      </Typography>
      <Box className={styles.content}>
        <section className={styles.extraInfo}>
          {!useMobile && (
            <Typography variant="h6" component="p" fontWeight="bolder" textAlign="left">
              {translate('contact.subTitle')}
            </Typography>
          )}
          <div className={styles.blocks}>
            <div className={styles.block}>
              <ButtonBase onClick={() => Map.navigateToClientCompany()}>
                <div className={styles.item}>
                  <Typography variant="body1" className={styles.title}>
                    {translate('contact.addressTitle')}
                  </Typography>
                  <Typography variant="body2" className={styles.text}>
                    {translate('contact.address')}
                  </Typography>
                </div>
              </ButtonBase>
            </div>
            <div className={styles.block}>
              <div className={styles.item}>
                <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
                  <Typography variant="body1" className={styles.title}>
                    {translate('contact.openingHoursTitle')}
                  </Typography>
                  <Typography variant="body2" className={styles.text} component="div">
                    <Box sx={{ textAlign: 'left' }}>{buildOpeningHours(translate('contact.openingHoursDays'), translate('openingHours'))}</Box>
                  </Typography>
                </Box>
              </div>
            </div>
            <div className={styles.block}>
              <ButtonBase component="a" href={`tel:${translate('client.phone')}`} target="_blank" classes={{ root: styles.link }}>
                <div className={styles.itemRow}>
                  <Typography variant="body1" className={styles.title}>
                    {translate('contact.phoneTitle')}
                  </Typography>
                  <Typography variant="body1" className={styles.text}>
                    {translate('client.phone')}
                  </Typography>
                </div>
              </ButtonBase>
              <ButtonBase component="a" href={`mailto:${translate('client.email')}`} classes={{ root: styles.link }}>
                <div className={styles.itemRow}>
                  <Typography variant="body1" className={styles.title}>
                    {translate('contact.emailTitle')}
                  </Typography>
                  <Typography variant="body1" className={styles.text}>
                    {translate('client.email')}
                  </Typography>
                </div>
              </ButtonBase>
            </div>
          </div>
        </section>
      </Box>
    </SectionWrap>
  );
};

export default ContactSimple;
